import { WriteupService } from '@/services/writeup';
import { StorageService } from '@/services/storage';
import { WebsiteService } from '@/services/website';
import { TradePendingService } from '@/services/tradepending';
import { CoreService } from '@/services/core';
import { LeadService } from '@/services/lead';
import { ShortUrlService } from '@/services/short-url';
import { DealProgressService } from '@/services/deal-progress-service';
import { ReserveVehicleService } from '@/services/reserve-vehicle';
import { AmplitudeService } from '@/services/amplitude-service';
import { AnalyticsService } from '@/services/analytics';


// TODO: use DI container
export class ServiceContainer {
	/* eslint-disable-next-line no-useless-constructor */
	constructor(public writeup: WriteupService,
				public website: WebsiteService,
				public storage: StorageService,
				public core: CoreService,
				public tradePending: TradePendingService,
				public shortUrl: ShortUrlService,
				public lead: LeadService,
				public dealProgress: DealProgressService,
				public analytics: AnalyticsService,
				public reserveVehicle: ReserveVehicleService,
				public amplitude: AmplitudeService) {
	}
}
